import { render, staticRenderFns } from "./vehicletypeTax.vue?vue&type=template&id=bdccc05e"
import script from "./vehicletypeTax.vue?vue&type=script&lang=js"
export * from "./vehicletypeTax.vue?vue&type=script&lang=js"
import style0 from "./vehicletypeTax.vue?vue&type=style&index=0&id=bdccc05e&prod&lang=css"
import style1 from "./vehicletypeTax.vue?vue&type=style&index=1&id=bdccc05e&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports